export const  LocationStartDate = 'locationStartDate'
export const  LocationEndDate = 'locationEndDate'
export const  LocationDateType = 'locationDateType'
